import React from 'react';

import { InquiryInner } from '@app/components/Pages/Inquiry/Inquiry';

const RequestDemo: React.FC = () => {
	return <section id="request-demo" className="request-demo payments-processing__item scroll-fix">
		<div className="request-demo__container payments-processing__container">
			<h2 className="request-demo__title">Request a Demo</h2>
			<div className="request-demo__form">
				<InquiryInner buttonTitle="Send" />
			</div>
		</div>
	</section>;
};

export default RequestDemo;
